// extracted by mini-css-extract-plugin
export default {"sk-bouncedelay":"TextEditor_sk-bouncedelay__2LfUL"};